import { TheMask } from 'vue-the-mask'
import countTo from 'vue-count-to'

export default {
  TheMask,
  countTo
}



// WEBPACK FOOTER //
// ./src/app/tenant/profile/me/components/overview/components/feed/resources/components.js